var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Map-1",
    width: "27px",
    height: "25px",
    viewBox: "0 0 27 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-view",
    transform: "translate(-869.000000, -364.000000)",
    fill: "#808285",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877.741461,364.659125 L869,366.390368 L869,388.5 L877.766352,386.763816 L887.258539,388.340875 L896,386.609632 L896,364.5 L887.233648,366.236184 L877.741461,364.659125 Z M879,366.5 L886,367.800099 L886,386.5 L879,385.199901 L879,366.5 Z M870,367.753866 L877,366.5 L877,385.246134 L870,386.5 L870,367.753866 Z M894,385.246134 L887,386.5 L887,367.753866 L894,366.5 L894,385.246134 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.a2275bd1a4db7d472b2c31a0ef97360f.svg";
export { ForwardRef as ReactComponent };